import React, {useEffect, useRef, useState} from 'react'
import {useTranslation} from 'react-i18next'

import {Box, Grid, TextField} from '@mui/material'
import * as Yup from 'yup'

import MobileStickyActions, {
  MOBILE_STICKY_HEIGHT,
} from '@progyny/components/MobileStickyActions'
import {useResponsive} from '@progyny/hooks/useResponsive'
import {CreateAccountSubProps} from '@progyny/pages/CreateAccount/types'

const City: React.FC<CreateAccountSubProps> = (props) => {
  const {
    navigator,
    callback,
    initialValue,
    persistMemberData,
    updateLoading,
    goBack,
  } = props
  const Navigator = navigator
  const isMobile = useResponsive('down', 'md')

  const [city, setCity] = useState<string>(initialValue.city || '')
  const [isTouched, setIsTouched] = useState<boolean>(false)
  const [error, setError] = useState<string>('')
  const {t} = useTranslation()
  const cityElement = useRef<HTMLInputElement>()

  const cityValidation = Yup.string()
    .required('City is required.')
    .max(200, t('create_account_city_city_name_must_be_at'))

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (!isTouched) setIsTouched(true)
    setCity(event.currentTarget.value)
  }

  async function submitForm() {
    await persistMemberData({city})
    callback()
  }

  useEffect(() => {
    try {
      cityValidation.validateSync(city)
      setError('')
    } catch (err) {
      setError((err as Yup.ValidationError).message)
    }
  }, [setError, cityValidation, city, isTouched])
  useEffect(() => {
    cityElement?.current?.focus()
  }, [])

  return (
    <Grid
      container
      justifyContent={'center'}
      mt={6}
      sx={{pb: {xs: MOBILE_STICKY_HEIGHT, md: 0}}}
    >
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          size={'medium'}
          label={t('create_account_city_enter_your_city')}
          variant={'outlined'}
          onChange={handleChange}
          margin={'none'}
          value={city}
          error={!!error && isTouched}
          helperText={!!error && isTouched && error}
          inputRef={cityElement}
          inputProps={{
            id: 'city',
            'aria-label': t('create_account_city_enter_your_city'),
          }}
          autoComplete={'city'}
        />
      </Grid>
      <Grid item xs={12}>
        <MobileStickyActions>
          <Navigator
            submitDataRole={'city'}
            label={t('common_continue')}
            onNextButtonClick={submitForm}
            buttonDisable={!!error || updateLoading}
            onPrevButtonClick={goBack}
            backButtonType='outlined'
            fullWidth={isMobile}
          />
        </MobileStickyActions>
      </Grid>
    </Grid>
  )
}

export default City
